import { Component, Input, OnInit } from '@angular/core';
import { BulkUploadService } from '../services/bulk-upload/bulk-upload.service';
import * as Papa from 'papaparse';
import { ModalController } from '@ionic/angular';
import { ResponseNotificationService } from '../services/response-notification/response-notification.service';


@Component({
  selector: 'app-bulk-upload',
  templateUrl: './bulk-upload.component.html',
  styleUrls: ['./bulk-upload.component.scss'],
})
export class BulkUploadComponent  implements OnInit {

  @Input() config!: any;

  rawCsvData: any[] = [];
  headers: string[] = [];
  mapping: { [key: string]: string } = {};
  mappedData: any[] = [];
  currentStep = 1;
  notesMessage!: string;

  constructor(
    private uploadService: BulkUploadService,
    private _modalController: ModalController,
    private _responseNotificationService: ResponseNotificationService
  ) {}

  ngOnInit(): void {
  }

  closeModal(){
    this._modalController.dismiss();
  }

  downloadSample() {
    const headerRow = this.config.fields.map((f:any) => f.label);
    const csv = Papa.unparse([headerRow]);
    const blob = new Blob([csv], { type: 'text/csv' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `${this.config.moduleName}_sample.csv`;
    a.click();
  }

  onFileUpload(event: any) {
    const file = event.target.files[0];
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        if (!results.data || results.data.length === 0) {
          this._responseNotificationService.showMessage('No data found in the uploaded file.', true);
          this.rawCsvData = [];
          this.headers = [];
          return;
        }
        this.rawCsvData = results.data;
        this.headers = Object.keys(results.data[0] as object);
        this.currentStep = 2;
      }
    });
  }

  mapAndTransformData() {
    this.mappedData = this.rawCsvData.map(row => {
      const obj: any = {};
      for (let [csvColumn, property] of Object.entries(this.mapping)) {
        obj[property] = row[csvColumn];
      }
      return obj;
    });
  }

  submit() {
    this._modalController.dismiss({
      mappedData: this.mappedData
    })
  }

  getAvailableProperties(currentHeader: string) {
    const selectedProperties = Object.entries(this.mapping)
      .filter(([header, property]) => header !== currentHeader && property)
      .map(([_, property]) => property);
    return this.config.fields.filter(
      (f: any) => !selectedProperties.includes(f.property) || this.mapping[currentHeader] === f.property
    );
  }

}
